<template>
  <div class="features__card" v-if="feature">
    <div :data-aos-delay="dataAosDelay" data-aos="fade-up">
      <h3 class="features__card__number">
        <span>
          <span v-if="feature.number < 10">0</span>{{ feature.number }}
        </span>
      </h3>
      <h4 class="features__card__title text-uppercase">
        {{ feature.title }}
      </h4>
      <p class="features__card__desc">{{ feature.desc }}</p>
    </div>

    <svg
      width="358"
      height="221"
      viewBox="0 0 358 221"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="hideSvgLine"
    >
      <path
        d="M1.74517 188.319C38.7553 220.669 132.041 254.741 209.103 132.228C305.43 -20.912 156.17 -35.4214 185.381 69.5084C214.592 174.438 286.046 219.819 357.241 194.026"
        stroke="white"
        stroke-opacity="0.5"
        stroke-width="3"
        stroke-dasharray="6 6"
        data-aos="draw-line"
        data-aos-duration="1000"
        data-aos-easing="linear"
        :data-aos-delay="dataAosSvgDelay"
        :data-aos-offset="windowHeight - 50"
      />
      <path
        d="M1.74517 188.319C38.7553 220.669 132.041 254.741 209.103 132.228C305.43 -20.912 156.17 -35.4214 185.381 69.5084C214.592 174.438 286.046 219.819 357.241 194.026"
        stroke="#040404"
        stroke-width="3"
        stroke-dasharray="6 6"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "feature-card",
  data() {
    return {
      windowHeight: window.outerHeight,
    };
  },
  props: {
    feature: {
      type: Object,
      required: true,
    },
    hideSvgLine: {
      type: Boolean,
      default: true,
    },
    dataAosDelay: {
      default: 300,
    },
    dataAosSvgDelay: {
      default: 800,
    },
  },
};
</script>
